<template>
	<div>
		<br />
		<div class="col-lg-12">
			<div class="row">
				<div class="col-sm-6">
					<span>Contato</span>
					<select
						:disabled="disabled"
						v-model="data.contato"
						class="form-control"
					>
						<option v-for="(cnts, id) in data.contatos" :value="id">
							{{ cnts.name }} <{{ cnts.mail }}>
						</option>
					</select>
				</div>

				<div class="col-md-2 col-sm-4">
					<span>Origem de cadastro</span>
					<select
						:disabled="disabled"
						v-model="data.origem_de_cliente"
						disabled
						class="form-control"
					>
						<option value="sms">SMS</option>
						<option value="app">SMSWEB - Aplicativo</option>
						<option value="offshore">Offshore</option>
					</select>
				</div>

				<div class="col-md-2 col-sm-4">
					<span>Tipo de contrato</span>
					<select
						:disabled="disabled"
						v-model="data.tipo_de_contrato"
						class="form-control"
					>
						<option value="avulso">Avulso</option>
						<option value="12MESES">12 Meses</option>
					</select>
				</div>

				<div class="col-md-2 col-sm-4">
					<span>Regiões</span>
					<select
						:disabled="disabled"
						v-model="data.regiao"
						class="form-control"
					>
						<option
							v-for="(regiao, index) in assets.regioes"
							:key="index"
							:value="regiao.regiao"
						>
							{{ regiao.regiao }}
						</option>
					</select>
				</div>
			</div>
			<br />

			<b>Endereço</b>
			<div class="well well-sm">
				<div class="row">
					<div class="col-sm-7">
						<span>Logradouro</span>
						<input
							:disabled="disabled"
							v-model="data.endereco.logradouro"
							type="text"
							class="form-control"
						/>
					</div>
					<div class="col-sm-2">
						<span>Numero</span>
						<input
							:disabled="disabled"
							v-model="data.endereco.numero"
							type="text"
							class="form-control"
						/>
					</div>
					<div class="col-sm-3">
						<span>Complemento</span>
						<input
							:disabled="disabled"
							v-model="data.endereco.complemento"
							type="text"
							class="form-control"
						/>
					</div>

					<div class="col-sm-4">
						<span>Bairro</span>
						<input
							:disabled="disabled"
							v-model="data.endereco.bairro"
							type="text"
							class="form-control"
						/>
					</div>

					<div class="col-sm-4">
						<span>Cidade</span>
						<input
							:disabled="disabled"
							v-model="data.endereco.localidade"
							type="text"
							class="form-control"
						/>
					</div>

					<div class="col-sm-2">
						<span>Cep</span>
						<input
							:disabled="disabled"
							v-model="data.endereco.cep"
							type="text"
							v-mask="'##.###-###'"
							placeholder="_____-___"
							class="form-control"
						/>
					</div>

					<div class="col-sm-2">
						<span>Estado</span>
						<select
							:disabled="disabled"
							v-model="data.endereco.uf"
							class="form-control"
						>
							<option
								v-for="(estado, index) in assets.estados"
								:key="index"
								:value="estado.uf_estado"
							>
								{{ estado.uf_estado }}
							</option>
						</select>
					</div>
				</div>
			</div>
			<!-- telefones e documentos -->
			<div class="row">
				<div class="col-md-5">
					<b>Telefones</b>
					<div class="well well-sm">
						<div class="row">
							<div class="col-sm-6">
								<span>Fixo</span>
								<input
									:disabled="disabled"
									v-model="data.telefones.fixo"
									type="text"
									v-mask="'(##) ####-####'"
									placeholder="(__) ____-____"
									class="form-control"
								/>
							</div>
							<div class="col-sm-6">
								<span>Celular</span>
								<input
									:disabled="disabled"
									v-model="data.telefones.celular"
									type="text"
									v-mask="'(##) #####-####'"
									placeholder="(__) _____-____"
									class="form-control"
								/>
							</div>
							<div class="col-sm-12">
								<span>Outros</span>
								<input
									:disabled="disabled"
									v-model="data.telefones.outros"
									type="text"
									class="form-control"
								/>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-7">
					<b>Documentação</b>
					<div class="well well-sm">
						<div class="row">
							<div class="col-sm-4">
								<span>IE</span>
								<input
									:disabled="disabled"
									v-model="data.documentos.ie"
									type="text"
									class="form-control"
								/>
							</div>

							<div class="col-sm-4">
								<span>IM</span>
								<input
									:disabled="disabled"
									v-model="data.documentos.im"
									type="text"
									class="form-control"
								/>
							</div>
							<div class="col-sm-4">
								<span>CNAE</span>
								<input
									:disabled="disabled"
									v-model="data.documentos.cnae"
									type="text"
									v-mask="'##.##-#-##'"
									placeholder="__.__-_-__"
									class="form-control"
								/>
							</div>
							<div class="col-sm-6">
								<span>Cipa</span>
								<input
									:disabled="disabled"
									v-model="data.documentos.cipa"
									type="text"
									class="form-control"
								/>
							</div>
							<div class="col-sm-6">
								<span>Data Doc</span>
								<input
									:disabled="disabled"
									v-model="data.documentos.data_doc"
									type="date"
									class="form-control"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import estados from 'js/estados';
	import clone from 'js/clone';
	import WBS from 'js/http';

	export default {
		name: 'ClientInformation',
		props: ['dIn', 'disabled'],
		data() {
			return {
				assets: {
					regioes: [],
					estados: clone(estados),
				},
			};
		},
		computed: {
			data() {
				return this.dIn;
			},
		},
		mounted() {
			WBS.send('protected-read-regions', (resp) => {
				this.assets.regioes = resp.data;
			});
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/cadastros/customers/components/informations.vue